<template>
  <section class="about-us">
    <h3 class="heading">
      <img
        loading="lazy"
        src="@/assets/images/pitchup-favicon.svg"
        class="favicon"
        width="21"
        height="19"
        alt=""
      />
      <translate>About us</translate>
    </h3>
    <translate
      tag="p"
      class="accommodation-intro"
      :tt="{ bookableCountriesCount: '67' }"
    >
      Book campsites, glamping sites and holiday parks in
      {bookableCountriesCount} countries.
    </translate>
    <ul>
      <li>
        <img
          loading="lazy"
          src="@/assets/images/tick-circle.svg"
          width="19"
          height="19"
          alt=""
        />
        <translate>Instant confirmation</translate>
      </li>
      <li>
        <img
          loading="lazy"
          src="@/assets/images/tick-circle.svg"
          width="19"
          height="19"
          alt=""
        />
        <translate>User reviews and photos</translate>
      </li>
      <li>
        <img
          loading="lazy"
          src="@/assets/images/tick-circle.svg"
          width="19"
          height="19"
          alt=""
        />
        <translate>No booking fees</translate>
      </li>
      <li>
        <img
          loading="lazy"
          src="@/assets/images/tick-circle.svg"
          width="19"
          height="19"
          alt=""
        />
        <translate>Multiple award winner</translate>
      </li>
    </ul>
    <feefo-badge class="feefo-badge" :show-service-rating="false" />
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class AboutPitchup extends Vue {}

export default toNative(AboutPitchup)
</script>

<style scoped>
section {
  padding: 1.4em;
}

p,
li {
  font-size: var(--body);
  color: var(--colour-wcag-blue);
  line-height: 1.2;
}

p {
  line-height: 1.4;
}

.heading {
  margin-left: 0 !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.favicon {
  width: 1em;
  margin-right: 0.25em;
}

ul {
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0 0 0;
  justify-content: space-between;
}

li {
  margin: 0 0 0.3em;
  padding: 0 0 0 1.4em;
  position: relative;
  flex-basis: 48%;
}

li img {
  display: inline-block;
  height: 1.2em;
  left: -0.2em;
  position: absolute;
  width: 1.2em;
}

.feefo-badge {
  margin: 1em 0;
}
</style>
